export const SET_BRANDING = "SET_BRANDING";
export const FETCH_BRANDING = "FETCH_BRANDING";
export const GET_BRANDING = "GET_BRANDING";
